module.exports = __webpack_public_path__ + "static/media/icon_specs-package.b01e11ae.svg";